// extracted by mini-css-extract-plugin
export default {"container":"BalanceMessage_container__e9ngQ"};